
const getLevelIndentationString = (lvl: number) => {

    let indentation = ''

    for (let i = 0; i < lvl; i++) {

        indentation += '-- '
    }

    return indentation
}

interface getWorksOptions {
  list: any[],
  currentWork: any,
  currentLabel: string,
  noNameText: string,
  level: number,
}

export const getWorksOptionsFromTaskList = (options: getWorksOptions) => {

  const { list, currentWork, currentLabel, noNameText } = options

  const lvl = options.level || 0

  const worksOptions: any[] = []

  list.forEach((item: any) => {

    if (item.type === 'task') {

      worksOptions.push({
          value: item.task._id,
          label: `${getLevelIndentationString(lvl)} ${item.task.name}`,
          isGroup: true,
      })

      if (item.task.hasSubTasks) {

        item.subTasks.forEach((subTask: any) => {

          worksOptions.push({
            value: subTask._id,
            label: `${getLevelIndentationString(lvl + 1)} ${currentWork._id === subTask._id ? `➤ ${subTask.name || noNameText} (this work)` : (subTask.name || noNameText)}`,
          })
        })
      }
    } else {

      worksOptions.push({
        value: item.group._id,
        label: `${getLevelIndentationString(lvl)} ${item.group.name}`,
        isGroup: true,
      })

      const subOptions = getWorksOptionsFromTaskList({
        list: item.group.items,
        currentWork,
        currentLabel,
        noNameText,
        level: lvl + 1,
      })

      worksOptions.push(...subOptions)
    }
  })

  return worksOptions
}

interface getItemsOptions {
  list: any[],
  currentItem: any,
  currentLabel: string,
  noNameText: string,
  level: number,
}

export const getItemsOptionsFromTaskList = (options: getItemsOptions) => {

  const { list, currentItem, currentLabel, noNameText } = options

  const lvl = options.level || 0

  const worksOptions: any[] = []

  list.forEach((item: any) => {

    if (item.type === 'task') {

      worksOptions.push({
          value: item.task._id,
          label: `${getLevelIndentationString(lvl)} ${currentItem._id === item.task._id ? `➤ ${item.task.name || noNameText} (${currentLabel})` : (item.task.name || noNameText)}`,
      })

      if (item.task.hasSubTasks) {

        item.subTasks.forEach((subTask: any) => {

          worksOptions.push({
            value: subTask._id,
            label: `${getLevelIndentationString(lvl + 1)} ${subTask.name}`,
            isGroup: true,
          })
        })
      }
    } else {

      worksOptions.push({
        value: item.group._id,
        label: `${getLevelIndentationString(lvl)} ${item.group.name}`,
        isGroup: true,
      })

      const subOptions = getItemsOptionsFromTaskList({
        list: item.group.items,
        currentItem,
        currentLabel,
        noNameText,
        level: lvl + 1,
      })

      worksOptions.push(...subOptions)
    }
  })

  return worksOptions
}

